import useScenarioCollection from '../useScenarioCollection/useScenarioCollection'
import { scenarioCollections } from './constants'
import { getHiddenBlocks, resolveOrderTrackingPreview } from './helpers'

const useCustomScenario = ({ storeId, orderTrackingPreview, dateLimitedBlocks, criteriaLimitedBlocks }) => {
  const items = useScenarioCollection({ storeId, collection: scenarioCollections.items })
  const shipments = useScenarioCollection({ storeId, collection: scenarioCollections.shipments })
  const returnRequests = useScenarioCollection({ storeId, collection: scenarioCollections.returnRequests })

  const resolvedOrderTrackingPreview = resolveOrderTrackingPreview({
    orderTrackingPreview,
    scenarioItems: items.entries,
    scenarioShipments: shipments.entries,
    scenarioReturnRequests: returnRequests.entries,
  })

  const hiddenBlocks = getHiddenBlocks({
    scenarioItems: items.entries,
    scenarioShipments: shipments.entries,
    scenarioReturnRequests: returnRequests.entries,
    dateLimitedBlocks,
    criteriaLimitedBlocks,
  })

  return {
    scenarioItems: items,
    scenarioShipments: shipments,
    scenarioReturnRequests: returnRequests,
    customScenarioPreview: { resolvedOrderTrackingPreview, hiddenBlocks },
  }
}

export default useCustomScenario
